module.exports = __webpack_public_path__ + "img/location 1.9af06c2f.svg";